import { DateTime } from "luxon";
import type { IAtom } from "mobx";
import { createAtom } from "mobx";

/**
 * Observable clock
 * from https://mobx.js.org/custom-observables.html
 */
class Clock {
  private atom: IAtom;
  private intervalHandler: ReturnType<typeof setInterval> | null = null;
  private currentDateTime: DateTime | undefined = undefined;

  constructor() {
    this.atom = createAtom(
      "Clock",
      () => this.startTicking(),
      () => this.stopTicking()
    );
  }

  getTime() {
    if (this.atom.reportObserved() && this.currentDateTime) {
      return this.currentDateTime;
    } else {
      // getTime was called, but not while a reaction was running, hence
      // nobody depends on this value, and the startTicking onBecomeObserved
      // handler won't be fired.
      return DateTime.now();
    }
  }

  tick() {
    this.currentDateTime = DateTime.now();
    this.atom.reportChanged();
  }

  startTicking() {
    this.tick();
    this.intervalHandler = setInterval(() => this.tick(), 1000);
  }

  stopTicking() {
    if (this.intervalHandler) clearInterval(this.intervalHandler);
    this.intervalHandler = null;
  }
}

export const clock = new Clock();
